import { Trial, ResponseStatus, ConfigurationTrial } from "@/api/dtos";
import { createContext } from "react"

export interface ITrialContext {
    data?: Trial;
    oid?: string;
    configuration?: ConfigurationTrial;
    error?: ResponseStatus;
    loading: boolean;
    validating: boolean;
    refresh: () => Promise<Trial | undefined>
}

export const TrialContext = createContext<ITrialContext>({
    loading: false,
    validating: false,
    data: undefined,
    error: undefined,
    refresh: () => {
        return new Promise<Trial | undefined>(res => {
            res(undefined);
        });
    }
});

export default TrialContext;